module.exports = __webpack_public_path__ + "img/boy-homework-sm.9686e127.png";